import { EntityMetadataBuilder, PropertyType } from "clavis-nxt-components-custdevtm";

const METADATA = new EntityMetadataBuilder("TranslationValueEntity")
    .entityPath("translationValue")
    .createProperty("id")
    .propertyType(PropertyType.STRING)
    .id()
    .finish()
    .createProperty("en")
    .propertyType(PropertyType.STRING)
    .finish()
    .createProperty("hu")
    .propertyType(PropertyType.STRING)
    .finish()
    .build();

export default METADATA;
